import React from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';

const AvatarHeader = ({ name, title, subtitle, children }) => {
  const { t } = useTranslation();
  return (
    <div className="avatar-header-containers">
      <div className="avatar-containers">{children}</div>
      <div className="avatar-info-wrapper">
        <h2 className="avatar-titles">
          {t(title)} {name}
        </h2>
        {subtitle && <p className="avatar-sub-titles">{t(subtitle)}</p>}
      </div>
    </div>
  );
};
export default AvatarHeader;
